import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router';
import { Alert } from '@sendgrid/ui-components';
import withAppIndicators from '../containers/withAppIndicators';
import LoadAnalytics from '../utils/Analytics';
import Header from './Header';
import FullPageLoader from './FullPageLoader';
import { ENVIRONMENT } from '../constants';
import getEnvVariable from '../utils/environment';
import SideBar from '../components/SideBar';
import Footer from './Footer';
import '../styles/signup.global.scss';
import accountTypes from '../constants/accountTypes';

class Layout extends React.Component {
  componentDidMount() {
    LoadAnalytics(null, getEnvVariable(ENVIRONMENT.SEGMENT_KEY));
  }

  render() {
    return (
      <Fragment>
        { this.props.appIndicators.alertActive &&
          <Alert
            type={this.props.appIndicators.alertType}
            onClick={() => this.props.dismissAlert()}
          >
            {this.props.appIndicators.alertText}
          </Alert>
        }
        { this.props.appIndicators.isPageLoading && <FullPageLoader /> }
        <main className="signup-base-wrapper">
          <article className="signup-container" data-role="signup-container">
            <section className="signup" data-role="signup-content">
              <Header title={this.props.title} subtitle={this.props.subtitle} />
              {this.props.children}
              <Footer />

            </section>
          </article>
          <Switch>
            <Route exact path="/account_details" component={null} />
            <Route exact path="/ads/account_details" component={null} />
            <Route exact path="/ads" render={props => <SideBar {...props} sideBarType={accountTypes.ads} />} />
            <Route exact path="/ads/billing" render={props => <SideBar {...props} sideBarType={accountTypes.ads} />} />
            <Route exact path="/declined" component={null} />
            <Route exact path="/update_email" component={null} />
            <Route render={props => <SideBar {...props} sideBarType={accountTypes.email} />} />
          </Switch>
        </main>

      </Fragment>
    );
  }
}

Layout.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
  ]).isRequired,
  dismissAlert: PropTypes.func.isRequired,
  appIndicators: PropTypes.shape({
    isPageLoading: PropTypes.bool.isRequired,
    alertActive: PropTypes.bool.isRequired,
    alertType: PropTypes.string.isRequired,
    alertText: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
    ]).isRequired,
  }).isRequired,
};

Layout.defaultProps = {
  subtitle: '',
};

export default withAppIndicators(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout.jsx